import { Flex } from '@fareye/ui'
import React from 'react'
import { AlertType as FeatureType, useTranslation } from '@fareye/common'
import { TChildUserConfigs, TValidConfigId } from '../../../utility/types'

interface IChildUserFeatureListing {
  featureConfig: TChildUserConfigs
  selectedFeatureType: string
  setSelectedFeatureType: (val: TValidConfigId) => void
}

export function ChildUserFeatureListing({
  featureConfig,
  setSelectedFeatureType,
  selectedFeatureType
}: IChildUserFeatureListing) {
  const { t } = useTranslation()
  return (
    <Flex
      column
      style={{
        boxShadow: '10px -2px 5px -6px rgba(230, 231, 231,.75)',
        height: '100%',
        overflow: 'auto'
      }}
    >
      {Object.keys(featureConfig).map((ele: string, index: number) => {
        return (
          <FeatureType
            onClick={() => {
              setSelectedFeatureType(ele as TValidConfigId)
            }}
            key={`alert${index}`}
            variant={`m ${selectedFeatureType === ele ? 'primary' : ''} `}
          >
            {t((featureConfig as any)[ele].label)}
          </FeatureType>
        )
      })}
    </Flex>
  )
}
